import colors from 'constants/colors';

const statusColorMap = {
  PENDING: colors.orange,
  CHECKED_IN: colors.darkGreen,
  CHECKED_OUT: colors.grey,
  CANCELLED: colors.red,
  EXPIRED: colors.red,
  PROCESSED: colors.blue,
  MIXED: colors.purple,
  default: colors.darkGrey
};

export default statusColorMap;